import feathersClient from '../../feathers-client';


const defaultStaffPagination = {
	total: 0,
	$skip: 0,
	$limit: 10,
};

const ddefaultStaffPaginationFilter = {
	$skip: defaultStaffPagination.$skip,
	$limit: defaultStaffPagination.$limit,
};
const defaultShiftPersonaPagination = {
	total: 0,
	$skip: 0,
	$limit: 10,
};

const defaultShiftPersonaPaginationFilter = {
	$skip: defaultStaffPagination.$skip,
	$limit: defaultStaffPagination.$limit,
};

const defaultSavedTemplatePagination = {
	total: 0,
	$skip: 0,
	$limit: 10,
};

const defaultSavedTemplatePaginationFilter = {
	$skip: defaultSavedTemplatePagination.$skip,
	$limit: defaultSavedTemplatePagination.$limit,
};

const defaultFavShiftPersonaPagination = {
	total: 0,
	$skip: 0,
	$limit: 10,
};

const defaultFavShiftPersonaPaginationFilter = {
	$skip: defaultFavShiftPersonaPagination.$skip,
	$limit: defaultFavShiftPersonaPagination.$limit,
};

export default {
    state:{
        staffUserList:[],
        staffUserFilter: ddefaultStaffPaginationFilter,
		staffUserPagination: defaultStaffPagination,
		shiftPersonaList:[],
		shiftPersonaFilter: defaultShiftPersonaPaginationFilter,
		shiftPersonaPagination: defaultShiftPersonaPagination,
		savedTemplateList:[],
		savedTemplateFilter: defaultSavedTemplatePaginationFilter,
		savedTemplatePagination: defaultSavedTemplatePagination,
		selectedPersona:[],
		selectedTemplate:null,
		shiftFavPersonaList:[],
		shiftFavPersonaFilter: defaultFavShiftPersonaPaginationFilter,
		shiftFavPersonaPagination: defaultFavShiftPersonaPagination,
    },
    getters: {
        staffUserPage: (state) => {
			const { $limit, $skip } = state.staffUserPagination;
			return $skip / $limit + 1;
		},
		shiftPersonaPage: (state) => {
			const { $limit, $skip } = state.shiftPersonaPagination;
			return $skip / $limit + 1;
		},
		savedTemplatePage: (state) => {
			const { $limit, $skip } = state.savedTemplatePagination;
			return $skip / $limit + 1;
		},
		shiftFavPersonaPage: (state) => {
			const { $limit, $skip } = state.shiftFavPersonaPagination;
			return $skip / $limit + 1;
		},
    },
    mutations: {
        SET_STAFF_LIST: (state, payload) => {
			state.staffUserList = payload;
		},
        SET_STAFF_USER_FILTER: (state, filter) => { state.staffUserFilter = { ...state.staffUserFilter, ...filter }; },
		SET_DEFAULT_STAFF_USER_FILTER: (state, filter) => { state.staffUserFilter = { ...filter, ...ddefaultStaffPaginationFilter }; },
		SET_STAFF_USER_PAGINATION: (state, data) => { state.staffUserPagination = { ...state.staffUserPagination, ...data }; },

		SET_SHIFT_PERSONA_LIST: (state, payload) => {
			state.shiftPersonaList = payload;
		},
        SET_SHIFT_PERSONA_FILTER: (state, filter) => { state.shiftPersonaFilter = { ...state.shiftPersonaFilter, ...filter }; },
		SET_DEFAULT_SHIFT_PERSONA_FILTER: (state, filter) => { state.shiftPersonaFilter = { ...filter, ...defaultShiftPersonaPaginationFilter }; },
		SET_SHIFT_PERSONA_PAGINATION: (state, data) => { state.shiftPersonaPagination = { ...state.shiftPersonaPagination, ...data }; },

		SET_SAVED_TEMPLATE_LIST: (state, payload) => {
			state.savedTemplateList = payload;
		},
        SET_SAVED_TEMPLATE_FILTER: (state, filter) => { state.savedTemplateFilter = { ...state.savedTemplateFilter, ...filter }; },
		SET_DEFAULT_SAVED_TEMPLATE_FILTER: (state, filter) => { state.savedTemplateFilter = { ...filter, ...defaultSavedTemplatePaginationFilter }; },
		SET_SAVED_TEMPLATE_PAGINATION: (state, data) => { state.savedTemplatePagination = { ...state.savedTemplatePagination, ...data }; },
		SET_SELECTED_PERSONA: (state, payload) => {
			state.selectedPersona = payload;
		},
		SET_SELECTED_TEMPLATE: (state, payload) => {
			state.selectedTemplate = payload;
		},
		UPDATE_STAFF_FILTER:(state,filter) => {
			state.staffUserFilter = {...state.staffUserFilter,...filter}
		},

		SET_FAV_SHIFT_PERSONA_LIST: (state, payload) => {
			state.shiftFavPersonaList = payload;
		},
        SET_FAV_SHIFT_PERSONA_FILTER: (state, filter) => { state.shiftFavPersonaFilter = { ...state.shiftFavPersonaFilter, ...filter }; },
		SET_FAV_DEFAULT_SHIFT_PERSONA_FILTER: (state, filter) => { state.shiftFavPersonaFilter = { ...filter, ...defaultFavShiftPersonaPaginationFilter }; },
		SET_FAV_SHIFT_PERSONA_PAGINATION: (state, data) => { state.shiftFavPersonaPagination = { ...state.shiftFavPersonaPagination, ...data }; },

    },
    actions:{
        setStaffUserPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.staffUserPagination.$limit;
			commit('SET_STAFF_USER_PAGINATION', { $skip });
			commit('SET_STAFF_USER_FILTER', { $skip });
		},
		setShiftPersonaPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.shiftPersonaPagination.$limit;
			commit('SET_SHIFT_PERSONA_PAGINATION', { $skip });
			commit('SET_SHIFT_PERSONA_FILTER', { $skip });
		},
		setFavShiftPersonaPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.shiftFavPersonaPagination.$limit;
			commit('SET_FAV_SHIFT_PERSONA_PAGINATION', { $skip });
			commit('SET_FAV_SHIFT_PERSONA_FILTER', { $skip });
		},
		setSavedTemplatePage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.savedTemplatePagination.$limit;
			commit('SET_SAVED_TEMPLATE_PAGINATION', { $skip });
			commit('SET_SAVED_TEMPLATE_FILTER', { $skip });
		},
        loadAllStaffUser: async ({ rootGetters, commit }, filter) => {
			const url = '/api/v3/find-a-staff';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...filter } });
			commit('SET_STAFF_LIST', results.data);
			commit('SET_STAFF_USER_PAGINATION', { total: results.total });
			return results;
		},
		setDefaultStaffUserFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_STAFF_USER_FILTER', filter);
		},
		setDefaultShiftPersonaFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_SHIFT_PERSONA_FILTER', filter);
		},
		setDefaultSavedTemplateFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_SAVED_TEMPLATE_FILTER', filter);
		},
		getUserRosterByDate:async ({commit,state,rootGetters},filter) => {
			const url = '/api/v3/get-staff-roster-availability-actions';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $getUserRoster: true, ...filter } });
			return results;
		},
		loadAllShiftPersona: async ({ rootGetters, commit }, filter) => {
			const url = '/api/v3/personas';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...filter } });
			if(filter.$favourite){
				commit('SET_FAV_SHIFT_PERSONA_LIST', results.data);
				commit('SET_SHIFT_PERSONA_PAGINATION', { total: results.total });
			} else {
				commit('SET_SHIFT_PERSONA_LIST', results.data);
				commit('SET_SHIFT_PERSONA_PAGINATION', { total: results.total });
			}
			return results;
		},
		addAsFavouritePersona:async({rootGetters},data) => {
			const url = '/api/v3/favourite-personas';
			const results = await feathersClient.service(url).create(data,{ query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		removeAsFavouritePersona:async({rootGetters},filter) => {
			const url = '/api/v3/favourite-personas';
			const results = await feathersClient.service(url).remove(null,{ query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		loadAllSavedTemplate: async ({ rootGetters, commit }, filter) => {
			const url = '/api/v3/find-a-staff-templates';
			const results = await feathersClient.service(url).find({ query: { 
				$role: rootGetters.currentUserRole,
				fields:['paramDetails'],
				$sort:{name:1},
				...filter 
			} });
			commit('SET_SAVED_TEMPLATE_LIST', results.data);
			commit('SET_SAVED_TEMPLATE_PAGINATION', { total: results.total });
			return results;
		},
		saveAsTemplate:async({rootGetters},data) => {
			const url = '/api/v3/find-a-staff-templates';
			const results = await feathersClient.service(url).create(data,{ query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateAsTemplate:async({rootGetters},data) => {
			const id = data.id
			delete data.id
			const url = '/api/v3/find-a-staff-templates';
			const results = await feathersClient.service(url).patch(id,data,{ query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		removeSavedTemplate:async({rootGetters},id) => {
			const url = '/api/v3/find-a-staff-templates';
			const results = await feathersClient.service(url).remove(id,{ query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		getTemplateById:async({rootGetters,commit},id) => {
			const url = '/api/v3/find-a-staff-templates';
			const results = await feathersClient.service(url).get(id,{ query: { $role: rootGetters.currentUserRole, fields:['paramDetails'] } });
			commit('SET_SELECTED_TEMPLATE', results);
			commit('SET_SELECTED_PERSONA', []);
			return results
		},
		getPersonasWithIds: async ({ rootGetters, commit,state }, filter) => {
			const url = '/api/v3/personas';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole,$getPersonaWithIds:true,paginate:false, fields:['favourites'],...filter } });
			commit('SET_SELECTED_TEMPLATE',null)
			commit('SET_SELECTED_PERSONA', results?.data);
			return results;
		},
		getMatchingCriteria:async({rootGetters,commit},filter) => {
			const url = '/api/v3/find-a-staff';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole,$matchingCriteria:true, ...filter } });
			return results;
		}
    },
}